import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../../Components/CipHeader";
import ClarificationsComponent from "./components/clarifications";
import ControlVerbalOrdersComponent from "./components/control-verbal-orders";

const Clarifications = ({ history }) => {

    const [tabIndex, setTabIndex] = useState(1);

    return (
        <>
            <CipHeader />
            <div className="w-5/6 mx-auto mt-6 h-screen overflow-hidden pb-36">
                <div className="ml-0">
                    <ul
                        className={`flex`}
                        role="tablist"
                    >
                        <li className="mr-2  text-center w-36 cursor-pointer">
                            <a
                                className={
                                    "text-xs font-bold uppercase px-2 py-3 shadow-lg  block leading-normal w-36 rounded-t-lg " +
                                    (tabIndex === 1 ? "text-black bg-header_bg border-b-0" : "  bg-menu_active")
                                }
                                onClick={(e) => {
                                    e.preventDefault();
                                    setTabIndex(1);
                                }}
                                data-toggle="tab"
                                role="tablist"
                            >
                                Clarifications
                            </a>
                        </li>
                        <li className="mr-2 flex-auto text-center w-36 cursor-pointer">
                            <a
                                className={
                                    "text-xs font-bold uppercase px-2 py-3 shadow-lg  block leading-normal w-52 rounded-t-lg " +
                                    (tabIndex === 2 ? "text-black bg-header_bg" : "  bg-menu_active")
                                }
                                onClick={(e) => {
                                    e.preventDefault();
                                    setTabIndex(2);
                                }}
                                data-toggle="tab"
                                href="#link2"
                                role="tablist"
                            >
                                Controlled Substances
                            </a>
                        </li>
                    </ul>
                </div>

                {tabIndex === 1 && (
                    <ClarificationsComponent />
                )}

                {tabIndex === 2 && (
                    <ControlVerbalOrdersComponent />
                )}
            </div >
        </>
    )

}

export default withRouter(
    connect(
        () => ({}),
        (dispatch) => {
            return bindActionCreators({}, dispatch);
        }
    )(Clarifications)
);